module.exports = __webpack_public_path__ + "img/explainer-dashboard.ba31243b.png";